import { BaseApi } from './base.api.js';

export class ClassificationApi extends BaseApi {
    constructor(client) {
        super(client, '/classification');
    }
}
